import React from 'react';
import { CheckCircle, Close } from '@mui/icons-material';
import EditIcon from '@mui/icons-material/Edit';
import { CircularProgress } from '@mui/material';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';

type OrderConfirmActionButtonsProps = {
    onCancel: (event: React.MouseEvent<HTMLButtonElement>) => void;
    onEdit: (event: React.MouseEvent<HTMLButtonElement>) => void;
    onConfirm: (event: React.MouseEvent<HTMLButtonElement>) => void;
    disabled?: boolean;
    loading?: boolean;
};

export const OrderConfirmActionButtons: React.FC<OrderConfirmActionButtonsProps> = (props) => {
    const disabled = props.disabled ?? false;
    const loading = props.loading ?? false;

    return (
        <Grid item container spacing={1.5} xs={11} sm={11}>
            <Grid item xs={6}>
                <Button
                    variant="outlined"
                    fullWidth
                    startIcon={<Close fontSize="small" />}
                    onClick={props.onCancel}
                    disabled={disabled || loading}
                    sx={{
                        borderColor: 'grey.300',
                        color: 'grey.600',
                        py: 1.5,
                        borderRadius: 2,
                        fontWeight: 'bold',
                        bgcolor: 'white'
                    }}
                >
                    取り消し
                </Button>
            </Grid>
            <Grid item xs={6}>
                <Button
                    variant="outlined"
                    fullWidth
                    startIcon={<EditIcon fontSize="small" />}
                    onClick={props.onEdit}
                    disabled={disabled || loading}
                    sx={{
                        borderColor: 'grey.300',
                        color: 'grey.600',
                        py: 1.5,
                        borderRadius: 2,
                        fontWeight: 'bold',
                        bgcolor: 'white'
                    }}
                >
                    修正
                </Button>
            </Grid>
            <Grid item xs={12}>
                <Button
                    variant="contained"
                    fullWidth
                    startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <CheckCircle />}
                    onClick={props.onConfirm}
                    disabled={disabled || loading}
                    disableElevation
                    sx={{
                        py: 1.5,
                        borderRadius: 2,
                        fontWeight: 'bold'
                    }}
                >
                    {loading ? '送信中…' : '配送依頼を確定する'}
                </Button>
            </Grid>
        </Grid>
    );
};
